module.exports = __webpack_public_path__ + "static/img/14000385.343087ef.png";